import styled from 'styled-components';
import { OptionsSelectStyled } from '../OptionsSelectStyled';
import { rem } from 'polished';

export const OptionsSelectStyledOV = styled(OptionsSelectStyled)`
    .Collapsible__trigger {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        &:after {
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='6' viewBox='0 0 26 14' fill='none'%3E %3Cpath d='M1 13L13 1L25 13' stroke='%23000000' stroke-width='3' stroke-linejoin='bevel'/%3E %3C/svg%3E");
        }
    }

    .option-list {
        .optionsTriggerWrapper {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        }
    }

    .selectedOptions {
        color: ${({ theme }) => theme.colors.white};
        background: ${({ theme }) => theme.colors.black};
    }
`;
